export class Country {
  constructor(
    public id: number,
    public name: string,
    public currency:string,
    public currencyFullName:string,
    public code: string
  ) { }
}
